exports = module.exports = require("./../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".d2analysis-gridheaders,.d2analysis-gridheaders *{border-color:#fff!important;background:#fff!important;font-size:10px!important;text-transform:uppercase!important;color:#666!important;font-weight:400!important}.d2analysis-gridheaders .x-btn-inner{padding-left:0!important}.d2analysis-gridheaders .x-btn-over *{color:#222!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/d2-analysis/css/ui/GridHeaders.css
 ** module id = 290
 ** module chunks = 0
 **/